import { render, staticRenderFns } from "./ShowMore.vue?vue&type=template&id=3ba2e751&scoped=true&"
import script from "./ShowMore.vue?vue&type=script&lang=js&"
export * from "./ShowMore.vue?vue&type=script&lang=js&"
import style0 from "./ShowMore.vue?vue&type=style&index=0&id=3ba2e751&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba2e751",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
